import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import AppStore from '../../store/AppStore'
import DtoStation from '../../sites/dto/DtoStation'
import { PATH_HOME } from '../constants/HomeConstants'
import { push } from 'react-router-redux'
import DtoPoint from '../../point/dto/DtoPoint'
import DtoUserRole from '../dto/DtoUserRole'
import i18n from 'simple-react-i18n'
import HomeAction from '../actions/HomeAction'

const $ = window.$

class Header extends Component {
	constructor(props) {
		super(props)
		this.state = {
			open: true
		}
	}

	componentDidUpdate() {
		$('.button-collapse').sideNav({
			closeOnClick: true
		})
	}

	goBack = () => {
		if (this.props.backPath) {
			AppStore.dispatch(push(this.props.backPath))
		} else {
			AppStore.dispatch(push(PATH_HOME))
		}
	}

	getNav() {
		if (this.props.isLogged) {
			if (this.props.point && this.props.point.code) {
				return (
					<span onClick={ () => this.goBack() }>
                    	<i className='material-icons font-size-40 brand-logo'>navigate_before</i>
                	</span>
				)
			}
			return (
				<a data-activates='slide-out' className='button-collapse show-on-large brand-logo left truncate'>
					<i className='material-icons'>menu</i>
				</a>
			)
		} else if (this.props.title === i18n.stationResearch) {
			return (
				<span onClick={ () => this.goBack() }>
					<i className='material-icons font-size-40 brand-logo'>navigate_before</i>
				</span>
			)
		}
		return null
	}

	getLink() {
		const classTitle = (() => {
			if (this.props.isLogged) {
				return 'left truncate margin-left-60 font-size-20'
			}
			return 'left truncate margin-left-40 font-size-20'
		})()
		return (
			<div className='show-on-large left clickable'>
				{ this.getNav() }
				<span className={ classTitle }>{ this.props.title }</span>
			</div>
		)
	}

	getActions = () => {
		if (this.props.isLogged) {
			if (this.props.actions && this.props.actions.length) {
				return this.props.actions.map((action, i) => {
					return (
						<li key={ i }>{ action }</li>
					)
				})
			}
			return null
		}
		return (
			<li key='logger'>
				<a onClick={ () => this.openLoginModal() }>
					<div className='row no-margin'>
						<div className='col s10 no-padding'>
							<span>Se connecter</span>
						</div>
						<div className='col s2 no-padding'>
							<i className='material-icons font-size-40'>person</i>
						</div>
					</div>
				</a>
			</li>
		)
	}

	openLoginModal = () => {
		AppStore.dispatch(HomeAction.updateLoginModalState(true))
	}

	render() {
		return (
			<div className='navbar-fixed'>
				<nav className='top-nav '>
					<div className='nav-wrapper '>
						{ this.getLink() }
						<ul className='right hide-on-med-and-down'>
							{ this.getActions() }
						</ul>
					</div>
				</nav>
			</div>
		)
	}

	componentDidMount() {
		$('.button-collapse').sideNav({
			closeOnClick: true
		})
	}
}

Header.propTypes = {
	title: PropTypes.string,
	stations: PropTypes.arrayOf(PropTypes.instanceOf(DtoStation)),
	actions: PropTypes.arrayOf(PropTypes.element),
	station: PropTypes.instanceOf(DtoStation),
	point: PropTypes.instanceOf(DtoPoint),
	userRoles: PropTypes.arrayOf(PropTypes.instanceOf(DtoUserRole)),
	backPath: PropTypes.string,
	isLogged: PropTypes.bool
}

const mapStateToProps = store => {
	return {
		title: store.HomeReducer.title,
		stations: store.SitesReducer.stations,
		actions: store.HomeReducer.actions,
		station: store.DetailStationReducer.station,
		backPath: store.HomeReducer.backPath,
		userRoles: store.HomeReducer.userRoles,
		point: store.PointReducer.point
	}
}

export default connect(mapStateToProps)(Header)



// WEBPACK FOOTER //
// ./src/home/components/Header.js